import Spinner from "components/common/Spinner/Spinner";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "redux/hooks";

const Loader = () => {
  const location = useLocation();

  const showOnboardingWizard = useAppSelector((state) => state.onboardingResponse.showOnboardingWizard);
  const showWizardLoader = useAppSelector((state) => state.onboardingResponse.showWizardLoader);

  const suggestedShowLoader = useAppSelector((state) => state.suggestedPlans.suggestedShowLoader);

  const isAdmin = useAppSelector((state) => state.app.isAdmin);
  const editEmailLoader = useAppSelector((state) => state.app.editEmailLoader);

  const myPlanShowLoader = useAppSelector((state) => state.myplans.MyPlans.myPlanShowLoader);

  const smeShowLoader = useAppSelector((state) => state.sme.smeShowLoader);
  const planDetailShowLoader = useAppSelector((state) => state.planDetails.planDetailShowLoader);

  const myPlanDetailShowLoader = useAppSelector((state) => state.myPlanDetails?.myPlanDetailShowLoader);
  const userValidationCheckLoader = useAppSelector((state) => state.myPlanDetails?.userValidationCheckLoader);

  const abovePropertyLoader = useAppSelector((state) => state.aboveProperty?.abovePropertyLoader);

  const planShowLoader = useAppSelector((state) => state.plans?.planShowLoader);
  const actionShowLoader = useAppSelector((state) => state.individualAction.actionShowLoader);

  const bookmarkShowLoader = useAppSelector((state) => state.bookmarkedPlans.bookmarkShowLoader);

  const status = useAppSelector((state) => state.Dashboard?.status);
  const userDashboardLoader = useAppSelector((state) => state.userDashboard.userDashboardLoader);

  const isDashboard = location.pathname.split("/")[1] === "";

  return (
    (myPlanShowLoader ||
      abovePropertyLoader ||
      planShowLoader ||
      planDetailShowLoader ||
      myPlanDetailShowLoader ||
      bookmarkShowLoader ||
      (isDashboard &&
        !isAdmin &&
        suggestedShowLoader &&
        !showOnboardingWizard &&
        (Object.values(status).some((v) => v === false) || suggestedShowLoader)) ||
      actionShowLoader ||
      smeShowLoader ||
      showWizardLoader ||
      userDashboardLoader ||
      editEmailLoader ||
      userValidationCheckLoader) && <Spinner backdropVisible />
  );
};

export default Loader;
